import { JsonConverter, JsonCustomConvert, JsonObject } from "json2typescript";

@JsonConverter
export class FrequencyConverter implements JsonCustomConvert<Frequency> {
  serialize() { }
  deserialize(data: any): Frequency {
    const frequency = new Frequency();
    frequency.gain = Number(data?.gain ?? 0);
    frequency.attenuationFactor = Number(data?.attenuationFactor ?? data?.attenuation_factor ?? 0);
    return frequency;
  }
}


@JsonObject("Frequency")
export class Frequency {
    gain: number = 0;
    attenuationFactor: number = 0;
    
}
